<div class="form-wrapper">
  <lsz-edit-form-header
    [headerText]="'Spiel- und Trainingsplätze'"
    [numEntries]="entries.length"
    [editMode]="editMode"
    (clickEdit)="onClickEdit()"
    (clickEditDone)="onClickEditDone()"
  ></lsz-edit-form-header>

  <table [class.editMode]="editMode" [formGroup]="allForms">
    <thead>
    <tr>
      <th i18n="@@tableHeaderName">Name</th>
      <th i18n="@@tableHeaderRemark">Bemerkung</th>
      <th i18n="@@tableHeaderFloodlight">Flutlicht</th>
      <th i18n="@@tableHeaderHeated">Heizung</th>
      <th i18n="@@tableHeaderCompetitionCompliant">Wettbewerbskonform</th>
      <th i18n="@@tableHeaderSurface">Belag</th>
      <th i18n="@@tableHeaderStadium">Stadion</th>
      <th i18n="@@tableHeaderOnLzArea">Auf LZ-Gelände</th>
      <th i18n="@@tableHeaderLzExclusive">Exkl. LZ-Nutzung</th>
      <th *ngIf="editMode" i18n="@@tableHeaderOptions" class="column-options">Optionen</th>
      <th>{{'lastEdit' | translate}}</th>
    </tr>
    </thead>
    <tbody lsz-lawn-field-form
           *ngFor="let form of customEntryForms.controls; let i = index"
           (entrySaved)="onUpdate(i)"
           (entryDeleted)="onDelete(i)"
           [editMode]="editMode"
           [index]="i"
           [form]="form"
           formArrayName="customEntries">
    </tbody>
    <tbody *ngIf="addMode" formGroupName="newEntry">
    <tr>
      <td>
        <input type="text" placeholder="Neuer Eintrag" i18n-placeholder="@@placeholderNewEntry" formControlName="name"
               required />
        <div *ngIf="name.invalid && (name.dirty || name.touched)">
          <div class="input-error" *ngIf="name.errors.required">Name wird benötigt.</div>
          <div class="input-error" *ngIf="name.errors.repeatedName">Name kann sich nicht wiederholen.</div>
        </div>
      </td>
      <td><textarea formControlName="remark"></textarea></td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'hasFloodlight'"></lsz-binary-select>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'isHeated'"></lsz-binary-select>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'isCompetitionCompliant'"></lsz-binary-select>
      </td>
      <td>
        <select formControlName="hasArtificialLawn" size="1" required>
          <option [ngValue]="false">Rasen</option>
          <option [ngValue]="true">Kunstrasen</option>
        </select>
        <div *ngIf="hasArtificialLawn.invalid && hasArtificialLawn.touched">
          <div class="input-error" *ngIf="hasArtificialLawn.errors.required">Auswahl wird benötigt.</div>
        </div>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'isStadium'"></lsz-binary-select>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'isOnLzArea'"></lsz-binary-select>
      </td>
      <td>
        <lsz-binary-select [form]="newEntryForm" [name]="'isLzExclusive'"></lsz-binary-select>
      </td>
      <td>
        <div class="form-options" fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center center">
          <button
            type="button"
            [disabled]="!newEntryForm.valid"
            (click)="createNewEntry()"
            class="nav-button"
            [ngClass]="{'notice': newEntryForm.valid}"
          >
            <fa-icon [icon]="faSave"></fa-icon>
          </button>
          <button type="button" (click)="exitAddMode()" class="nav-button">
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>

  <button *ngIf="editMode && !addMode" type="button" (click)="addNewRow()" i18n="@@dataButtonAdd" class="add-button">
    <fa-icon [icon]="faPlus"></fa-icon>
    Neuen Eintrag hinzufügen
  </button>
</div>
